// Footer shared by every page: copyright, platform contact, policy links and cookie settings.
import { Link } from 'react-router-dom';
import { Mail } from 'lucide-react';
import { COPYRIGHT_YEAR, LEGAL_DOCS, SITE, getWhatsAppHelplineUrl } from '../lib/site';
import { openCookieSettings } from './CookieConsent';
import { WhatsAppIcon } from './WhatsAppIcon';

export function LegalLinks() {
  return (
    <nav className="legal-links" aria-label="Policies">
      {LEGAL_DOCS.map((d) => <Link key={d.id} to={`/legal/${d.id}`}>{d.title}</Link>)}
      <button type="button" className="link-button" onClick={openCookieSettings}>Cookie settings</button>
    </nav>
  );
}

export function Copyright() {
  return <span className="copyright">© {COPYRIGHT_YEAR} {SITE.operator} · {SITE.product}. All rights reserved.</span>;
}

export function ContactLink() {
  return <a className="contact-link" href={`mailto:${SITE.contactEmail}`}><Mail size={13} aria-hidden />{SITE.contactEmail}</a>;
}

export function WhatsAppLink({ role }: { role?: string | null }) {
  return (
    <a
      className="contact-link"
      href={getWhatsAppHelplineUrl(role)}
      target="_blank"
      rel="noopener noreferrer"
      title={`WhatsApp Helpline: ${SITE.whatsappDisplay}`}
    >
      <WhatsAppIcon size={13} style={{ color: '#16a34a' }} />
      WhatsApp: {SITE.whatsappDisplay}
    </a>
  );
}

/** Compact two-line footer for the signed-in workspace and sign-in pages. */
export function SiteFooter({ note, role }: { note?: string; role?: string | null }) {
  return (
    <footer className="site-footer">
      <div className="site-footer-row">
        <Copyright />
        <div className="row" style={{ gap: 14 }}>
          <WhatsAppLink role={role} />
          <ContactLink />
        </div>
      </div>
      <div className="site-footer-row">
        <LegalLinks />
        {note && <span className="tiny muted">{note}</span>}
      </div>
    </footer>
  );
}
